export const ChartIds = {
  Vessel_Speed: 'Vessel_Speed',
  Total_Fuel_Consumption: 'Total_Fuel_Consumption',
  Engine_Power: 'Engine_Power',
  Engine_Speed: 'Engine_Speed',
  Wind_Speed: 'Wind_Speed',
  Propeller_Slip: 'Propeller_Slip',
  Drafts: 'Drafts',
  Engine_Loading: 'Engine_Loading',
  Wind_Speed_Per_Limits: 'Wind_Speed_Per_Limits',
  Engine_Speed_Limits: 'engineSpeedDistributionBar',
  Speed_Over_Ground_Limits: 'Speed_Over_Ground_Limits',
  Steaming: 'Steaming',
  Auxiliary_Engines_Power: 'Auxiliary_Engines_Power',
  Diesel_Generator_Running_Hours: 'Diesel_Generator_Running_Hours',
  Fuel_Oil_Consumption: 'Fuel_Oil_Consumption',
  Boiler_Fuel_Oil_Consumption: 'Boiler_Fuel_Oil_Consumption',
  Auxiliary_Engines_Fuel_Oil_Consumption:
    'Auxiliary_Engines_Fuel_Oil_Consumption',
} as const;

export type ChartId = (typeof ChartIds)[keyof typeof ChartIds];
